namespace advisorop.components.advisor {

    class AdministrationAdvisorController {

        $router;
        public model: domains.IAdvisor;
        advisory: domains.IAdvisor;
        rolesNames: any;
        selectedCompanyGroup: domains.ICompanyGroup;
        advisors: Array<domains.IAdvisor> = [];
        public dg: DevExpress.ui.dxDataGridOptions; 



        static $inject = ["identityService", "generalService", "advisorService"];
        constructor(private identityService: services.IdentityService,
            private generalService: services.GeneralService, private advisorService: services.AdvisorService) {


            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Advisors"
                },
                bindingOptions: {
                    dataSource: "vm.advisors"
                },
                //height: "350px",
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                //stateStoring: {
                //    enabled: true,
                //    type: "localStorage",
                //    storageKey: "dgAdvisorsSettings"
                //},
                columnChooser: {
                    enabled: true,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: 'fullName', caption: 'Name', cellTemplate: 'colFullName' },
                    { dataField: 'repNumber', caption: 'Rep Num.', width: 70, visible: true },
                    { dataField: 'tinForPublic', caption: 'TIN/SSN', width: 140, visible: false },
                    { dataField: 'fullAddress', caption: 'Address', width: 200, visible: false },
                    { dataField: 'companyGroup.companyName', caption: 'Firm', visible: false },
                    { dataField: 'contactFullName', caption: 'Contact', visible: false },
                    { dataField: 'contactEmail', caption: 'E-mail', visible: false },
                    { dataField: 'systemLogin.username', caption: 'Username', visible: true, width: 90 },
                    { dataField: 'systemLogin.role', caption: 'Role', visible: true, width: 110 },
                    { dataField: 'systemLogin.loginStatusDesc', caption: 'Login stat.', visible: true, width: 80 },
                    { dataField: 'id', caption: '#', cellTemplate: 'btnActions', width: 160 }

                ],
                //selection: {
                //    mode: 'single',
                //    showCheckBoxesMode: 'onClick'
                //},
                //onSelectionChanged: function (selectedItems) {
                //    var data = selectedItems.selectedRowsData[0];
                //    if (data) {
                //        this.vm.onAdvisorChanged({ id: data.id });
                //    }
                //}
            };


        }



        //companyGroupSelected(companyGroup: domains.ICompanyGroup): void {
        //    this.selectedCompanyGroup = companyGroup;
        //};

        $onInit(): void {
           
        }


        $routerOnActivate(next, previous) {
        }
    }


    class AdministrationAdvisor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<",
                advisors: "<"
            };
            this.controller = AdministrationAdvisorController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/administration-advisor.html';
        }
    }
    angular.module(Constants.APP).component("administrationAdvisor", new AdministrationAdvisor());


}